import styled from "styled-components";

export const Testes = styled.div`
  margin-block: 20px;
  margin-inline: 50px;
`;

export const FormPayment = styled.div`
  padding-block: 24px;
  padding-inline: 80px;
  gap: 16px;

  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 18px;
    margin-bottom: 12px;
  }

  span {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
  }

  label {
    font-size: 16px;
  }
`;

export const FormPaymentType = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  @media screen and (max-width: 380px) {
    display: block;
    width: 70%;
    margin-inline: 15%;
  }
`;

export const InputFormPayment = styled.div`
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  padding: 2%;
  border: 1px solid rgba(84, 84, 84, 0.7);
  --tw-border-opacity: 0.75;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fdebae;
  margin-top: 10px;
  margin-bottom: 20px;

  &:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
`;

export const FlagsContainerRow = styled.div`
  justify-content: space-around;
  margin-inline: 50px;
`;

export const FlagsContainer = styled.div`
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 20px;
  width: 105px;

  @media screen and (min-width: 1024px) {
    margin-left: 8px;
    margin-right: 8px;
  }

  @media screen and (min-width: 421px) and (max-width: 700px) {
    width: 30%;
  }
`;

export const CheckoutTypeFlags = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 52.06px;
  object-fit: contain;
  padding: 4px;
  border: 1px solid rgba(84, 84, 84, 0.7);
  --tw-border-opacity: 0.75;
  border-radius: 8px;
  cursor: pointer;
  background-color: #fdebae;

  &:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity));
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
`;

export const ImgFlag = styled.img`
  height: 28px;
`;

export const InfoUserCardBox = styled.div`
  .divCardNumber {
    width: 66%;
  }
  .divValidity {
    width: 33%;
  }
  .divNameTitular {
    width: 66%;
    .inputNameTitular {
      padding-inline: 10px;
    }
  }
  .divSecurityCode {
    width: 33%;
  }
  .divParcelNumber {
    width: 33%;
  }

  margin: 24px 0;

  span {
    margin-left: 3px;
    font-size: 16px;
  }

  @media screen and (max-width: 900px) {
    span {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 420px) {
    .divCardNumber {
      width: 58%;
    }
    .divValidity {
      width: 42%;
    }
    .divNameTitular {
      width: 100%;
    }
    .divSecurityCode {
      width: 46%;
    }
    .divParcelNumber {
      width: 48%;
    }
  }
`;

export const CheckoutLPLabelInput = styled.div`
  display: flex;
  margin: 10px 0;
  width: auto;
  align-items: center;

  a {
    color: #00629b;
    margin-left: 5px;
  }

  @media screen and (max-width: 420px) {
    label {
      font-size: 10px;
    }
  }

  .questionImg {
    padding-inline: 5px;
  }
`;

export const InputCardNumber = styled.input`
  border: 1px solid #989898;
  border-radius: 10px;
  width: 95%;
  height: 52px;
  padding-right: 20%;
  padding-left: 20%;
  outline: none;
  font-size: 20px;
  ::placeholder {
    font-size: 16px;
  }

  /* ${(props) => {}} */

  /* :disabled {
    opacity: 1;
  } */
  @media screen and (max-width: 425px) {
    padding-right: 10%;
    padding-left: 10%;
    font-size: 15px;
    ::placeholder {
      font-size: 12px;
    }
  }
`;

export const BoxSelectCheckoutLP = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 10px;
  width: 92%;
`;

export const SelectCheckoutPayment = styled.select`
  border: 1px solid #ddd;
  outline: none;
  height: 52px;
  margin: 10px 0;
  width: 100%;
  text-align: center;
  border: 1px solid #989898;
  border-radius: 12px;
  font-weight: 400;
  color: #545454;
`;

export const InputCardName = styled.input`
  border: 1px solid #989898;
  border-radius: 10px;
  width: 95%;
  height: 52px;
  padding-right: 6px;
  padding-left: 6px;
  outline: none;
  text-transform: uppercase;
`;

export const InputSecurityCode = styled.input`
  border: 1px solid #989898;
  border-radius: 10px;
  width: 90%;
  height: 52px;
  padding-right: 6px;
  padding-left: 6px;
  outline: none;
  text-align: center;
  font-size: 17px;
`;

export const CheckoutAllowTerms = styled.div`
  display: flex;
  align-items: center;

  input {
    margin-right: 10px;
    height: 18px;
    width: 18px;
  }

  a {
    color: var(--color-azul-mrpay);
  }
`;

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Option = styled.div`
  background-color: ${(props) => (props.selected ? "lightgray" : "white")};
  padding: 10px;
  cursor: pointer;
  width: 45%;
  position: relative;
`;

export const InfoContainer = styled.div`
  display: ${(props) => (props.show ? "flex" : "none")};
  flex-direction: column;
  position: absolute;
  top: 40px;
  left: 0;
  background-color: lightgray;
  padding: 10px;
`;

export const Info = styled.div`
  margin-bottom: 10px;
`;

export const DivTeste = styled.div`
  width: 100%;
  height: 500px;
  padding: 20px;
`;

export const Forms = styled.form`
  padding: 20px;
`;

export const Button = styled.button`
  width: 150px;
  height: 40px;
`;

export const OptionTeste = styled.option`
  
`;

export const DataList = styled.datalist`
  
`;

export const DataListColors = styled.datalist`
  
`;

export const InputTeste = styled.input`
  
`;
export const InputTesteColors = styled.input`
  
`;